import './utils/geocoding';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Fuerza la inclusión del módulo geocoding (previene tree-shaking)
const _forceGeocoding = typeof window !== 'undefined' ? window.__GEOCODING_LOADED : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
